"use client";

import { Button } from "@/components/ui/button";
import { MessageCircle, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectContactMap() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const serviceAreas = ["Riyadh", "Jeddah", "Mecca (Makkah)", "Medina (Madinah)", "Dammam", "Khobar", "Dhahran", "Tabuk", "Buraidah", "Khamis Mushait", "Hail", "Najran", "Jizan", "Yanbu", "Al Kharj", "Abha", "Taif", "Jubail", "Hofuf", "Al Qatif"];
  return <section id="direct-contact-map" className="relative bg-dark-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div ref={containerRef} className={`grid grid-cols-1 lg:grid-cols-3 gap-8 ${containerVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          {}
          <div className="flex justify-center lg:justify-start">
            <Button variant="outline" size="lg" className="w-full max-w-xs h-auto py-6 bg-transparent border-2 border-accent text-foreground-dark hover:bg-accent-dark hover:border-accent-hover hover:-translate-y-0.5 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" onClick={() => window.open("https://wa.me/966533589882", "_blank", "noopener,noreferrer")}>
              <MessageCircle className="size-6" />
              <span className="text-lg font-semibold">WhatsApp Us</span>
            </Button>
          </div>

          {}
          <div className="flex justify-center">
            <Button size="lg" className="w-full max-w-xs h-auto py-6 bg-accent text-foreground-accent hover:bg-accent-dark hover:-translate-y-0.5 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" onClick={() => window.location.href = "tel:+966533589882"}>
              <Phone className="size-6" />
              <span className="text-lg font-semibold">Call Now</span>
            </Button>
          </div>

          {}
          <div className="flex justify-center lg:justify-end">
            <div ref={mapRef} className={`relative w-full max-w-xs h-64 rounded-lg overflow-hidden shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ${mapVisible ? "animate-fade-in-up" : "opacity-0"}`}>
              <div className="relative w-full h-full">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529178/img/ksa_service_area_map.png" alt="Service Area Map" className="w-full h-full object-cover grayscale" />
              </div>
              <div className="absolute top-4 right-4 bg-primary/80 backdrop-blur-sm text-foreground-primary px-3 py-2 rounded-md text-xs font-semibold">
                Service Areas
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 text-center">
          <h3 className="text-foreground-dark text-xl font-display font-semibold mb-6">
            Areas We Serve
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            {serviceAreas.map((area, i) => <span key={i} data-index={i} className={`text-foreground-dark/80 text-sm px-4 py-2 bg-primary/40 backdrop-blur-sm rounded-full ${containerVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}`} style={{
            animationDelay: `${100 + i * 50}ms`
          }}>
                {area}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}